import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {MatDialogRef} from '@angular/material';

@Component({
  selector: 'awair-create-floor-dialog',
  templateUrl: './create-floor-dialog.component.html',
  styleUrls: ['./create-floor-dialog.component.scss']
})
export class CreateFloorDialogComponent implements OnInit {

  @Output() create: EventEmitter<string> = new EventEmitter<string>();
  isLoading: boolean = false;

  private floorName: string = '';

  constructor(private myDialogRef: MatDialogRef<CreateFloorDialogComponent>) {
  }

  ngOnInit() {
  }

  onChangeName(name: string): void {
    this.floorName = name;
  }

  onCreate(): void {
    this.isLoading = true;
    this.create.emit(this.floorName);
  }

  onCancel(): void {
    this.myDialogRef.close();
  }
}
